import React from 'react';
import { Icon } from 'js/components';
import { useParams, Link } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';

function NoProductManagersCard({ type = 'default' }) {
  const { workspaceId } = useParams();

  return (
    <Card>
      <CardBody>
        {type === 'archived' ? (
          <div className="media text-muted mt-4 mb-4">
            <Icon
              icon={['fal', 'spider-web']}
              size="4x"
              className="mr-3"
              fixedWidth
            />
            <div className="media-body">
              <p>You don't have any archived products.</p>
              <p>
                Archiving a product suspends it from your account while
                preserving its connections for historical purposes. We recommend
                archiving products you no longer use to keep your account tidy.
              </p>
            </div>
          </div>
        ) : (
          <div className="media text-muted mt-4 mb-4">
            <Icon
              icon={['far', 'star-exclamation']}
              size="4x"
              className="mr-3"
              fixedWidth
            />
            <div className="media-body">
              <p>You don't have any active products.</p>
              <p>
                Products help you organize and track the health of your
                capabilities across teams and user groups. Use them to better
                identify and prioritize issues.
              </p>

              <div>
                <Link
                  to={`/w/${workspaceId}/pm/products/new`}
                  className="create-link btn btn-primary"
                >
                  <Icon icon="plus" className="btn-icon-left" /> Add a product
                </Link>
              </div>
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  );
}

export default NoProductManagersCard;
